import { prop } from "../../decorators/property";
import { AppSettings } from "../../app-settings";
import { AuthorizationModel } from "../../authentication/models/authorization-model";

export class AlertsSearchModel extends Backbone.AssociatedModel {
    @prop() public Id: number;
    @prop() public Enabled: boolean;
    @prop() public Search: any;
    @prop() public Name: string;
    @prop() public Subject: string;

    constructor(options?) {
        super(options);
    }

    public updateSearchAlert(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "PUT",
                url: `${AppSettings.ApiUrlPrefix}alerts/search/update/${this.Id}`,
                data: this.toJSON()
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    public deleteSearchAlert(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                url: `${AppSettings.ApiUrlPrefix}alerts/search/delete/${this.Id}`,
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                method: "DELETE",
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/alerts-search.ts